export default __webpack_public_path__ + "static/media/SWT1220.34I-35698_-20812_0.cf302e2d.jpg";